import React from 'react';

import { Section } from './Section';
import { UL } from './UL';
import { LI } from './LI';

export const LE3_7 = () => (
  <Section>

    <UL>
      <LI>
        Erweitern Sie die <b>Mind-Map</b> aus der Lerneinheit 1 um neue Begriffe, die den SuS nun noch zusätzlich einfallen.
      </LI>
    </UL>

  </Section>
);



// WEBPACK FOOTER //
// ./src/components/LE/LE3_7.js